module.exports = __webpack_public_path__ + "img/favourites.2fe21de.svg";